const CONFIG = {
  API_URL: process.env.VUE_APP_API || 'https://dev.api.commutrics.com/api',
  MAPS_KEY: process.env.VUE_APP_MAPS_KEY || 'AIzaSyDMsNUCCfRtGw7NGNMuM14qVWLeb91fv2E',
};

export default CONFIG;
